import { render, staticRenderFns } from "./CommunityPostMedia.vue?vue&type=template&id=a064e782&scoped=true&"
import script from "./CommunityPostMedia.vue?vue&type=script&lang=js&"
export * from "./CommunityPostMedia.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPostMedia.vue?vue&type=style&index=0&id=a064e782&lang=sass&scoped=true&"
import style1 from "./CommunityPostMedia.vue?vue&type=style&index=1&id=a064e782&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a064e782",
  null
  
)

export default component.exports